import { Sparkles, Settings, HelpCircle } from 'lucide-react';

export default function Header() {
  return (
    <header className="bg-base-100 border-b border-base-300 px-4 py-3 shadow-sm">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        {/* Logo and Title */}
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-primary to-secondary rounded-xl flex items-center justify-center shadow-md">
            <Sparkles className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-xl font-bold text-base-content">
              AI Avatar
            </h1>
            <p className="text-xs text-base-content/60 hidden sm:block">
              Tu asistente personal con voz
            </p>
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-2">
          <button 
            className="btn btn-ghost btn-sm btn-circle"
            aria-label="Ayuda"
            title="Ayuda"
          >
            <HelpCircle className="w-5 h-5" />
          </button>
          <button 
            className="btn btn-ghost btn-sm btn-circle"
            aria-label="Configuración"
            title="Configuración"
          >
            <Settings className="w-5 h-5" />
          </button>
        </div>
      </div>
    </header>
  );
}